export default __webpack_public_path__ + "static/media/img-stake-sent-mobile.cc2439a8.png";